export const COLORS_TAGS = {
  "Sin idea": "magenta",
  "Idea": "cyan",
  "Prototipo": "green",
  "En operación": "geekblue",
  "En crecimiento": "orange",
  "En consolidación": "purple"
};